<form [formGroup]="solarEnergyForm" class="solar-energy-form">
  <div class="form-section">
    <div class="form-grid">
      <div class="form-group">
        <span class="group-label required"
          >Are you interested in finding a Solar provider or obtaining a Solar
          Loan?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="solarYes"
              type="radio"
              formControlName="interestedInSolar"
              [value]="true"
            />
            <label for="solarYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="solarNo"
              type="radio"
              formControlName="interestedInSolar"
              [value]="false"
            />
            <label for="solarNo">No</label>
          </div>
        </div>
        @if (
          solarEnergyForm.get("interestedInSolar")?.touched &&
          solarEnergyForm.get("interestedInSolar")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <div class="form-group">
        <span class="group-label required"
          >Are you interested in exploring Energy Efficiency upgrades in your
          building/business?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="efficiencyYes"
              type="radio"
              formControlName="interestedInEnergyEfficiency"
              [value]="true"
            />
            <label for="efficiencyYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="efficiencyNo"
              type="radio"
              formControlName="interestedInEnergyEfficiency"
              [value]="false"
            />
            <label for="efficiencyNo">No</label>
          </div>
        </div>
        @if (
          solarEnergyForm.get("interestedInEnergyEfficiency")?.touched &&
          solarEnergyForm.get("interestedInEnergyEfficiency")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <div class="form-group">
        <label for="buildingAge">When was your building built?</label>
        <input
          id="buildingAge"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          formControlName="buildingAge"
          placeholder="Enter year (e.g., 2020)"
          maxlength="4"
        />
        @if (
          solarEnergyForm.get("buildingAge")?.touched &&
          solarEnergyForm.get("buildingAge")?.invalid
        ) {
          @if (solarEnergyForm.get("buildingAge")?.errors?.["futureYear"]) {
            <span class="error-message"
              >Building built year cannot be in the future</span
            >
          } @else if (
            solarEnergyForm.get("buildingAge")?.errors?.["invalidYear"]
          ) {
            <span class="error-message"
              >Please enter a valid 4-digit year (e.g., 2020) between 1900 and
              current year</span
            >
          } @else {
            <span class="error-message"
              >Please enter a valid 4-digit year between 1900 and
              {{ currentYear }}</span
            >
          }
        }
      </div>

      <div class="form-group full-width">
        <label for="buildingImprovements"
          >If you are familiar with the building, can you list the improvements
          or upgrades made to it over the past 10 years?</label
        >
        <textarea
          id="buildingImprovements"
          formControlName="buildingImprovements"
          rows="4"
        ></textarea>
      </div>

      <div class="form-group full-width">
        <label for="powerProviders"
          >Can you list the power and utility providers that service your
          building?</label
        >
        <textarea
          id="powerProviders"
          formControlName="powerProviders"
          rows="3"
        ></textarea>
      </div>

      <div class="form-group">
        <span class="group-label required"
          >Are you interested in adding batteries to your business
          property?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="batteriesYes"
              type="radio"
              formControlName="interestedInBatteries"
              value="yes"
            />
            <label for="batteriesYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="batteriesNo"
              type="radio"
              formControlName="interestedInBatteries"
              value="no"
            />
            <label for="batteriesNo">No</label>
          </div>
          <div class="radio-item">
            <input
              id="batteriesUnsure"
              type="radio"
              formControlName="interestedInBatteries"
              value="unsure"
            />
            <label for="batteriesUnsure">Unsure</label>
          </div>
        </div>
        @if (
          solarEnergyForm.get("interestedInBatteries")?.touched &&
          solarEnergyForm.get("interestedInBatteries")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <div class="form-group">
        <span class="group-label required"
          >Can you provide a building power-use statement for the past few
          months?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="powerStatementYes"
              type="radio"
              formControlName="canProvidePowerStatement"
              [value]="true"
            />
            <label for="powerStatementYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="powerStatementNo"
              type="radio"
              formControlName="canProvidePowerStatement"
              [value]="false"
            />
            <label for="powerStatementNo">No</label>
          </div>
        </div>
        @if (
          solarEnergyForm.get("canProvidePowerStatement")?.touched &&
          solarEnergyForm.get("canProvidePowerStatement")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <div class="form-group">
        <span class="group-label required"
          >Do you have any electric vehicles?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="hasEVYes"
              type="radio"
              formControlName="hasElectricVehicles"
              [value]="true"
            />
            <label for="hasEVYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="hasEVNo"
              type="radio"
              formControlName="hasElectricVehicles"
              [value]="false"
            />
            <label for="hasEVNo">No</label>
          </div>
        </div>
        @if (
          solarEnergyForm.get("hasElectricVehicles")?.touched &&
          solarEnergyForm.get("hasElectricVehicles")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <div class="form-group">
        <span class="group-label required"
          >Are you looking to add an electric vehicle to your fleet?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="addEVYes"
              type="radio"
              formControlName="interestedInElectricVehicle"
              [value]="true"
            />
            <label for="addEVYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="addEVNo"
              type="radio"
              formControlName="interestedInElectricVehicle"
              [value]="false"
            />
            <label for="addEVNo">No</label>
          </div>
        </div>
        @if (
          solarEnergyForm.get("interestedInElectricVehicle")?.touched &&
          solarEnergyForm.get("interestedInElectricVehicle")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <!-- Credit Score Range (conditionally shown) -->
      @if (shouldShowCreditScoreQuestion) {
        <div class="form-group full-width">
          <label for="creditScoreRange"
            >Can you self-report your credit score range?</label
          >
          <select id="creditScoreRange" formControlName="creditScoreRange">
            <option value="">Select a range</option>
            @for (scoreRange of creditScoreOptions; track scoreRange) {
              <option [value]="scoreRange">{{ scoreRange }}</option>
            }
          </select>
        </div>
      }
    </div>
  </div>
</form>
